import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

interface TenantPickerSkeletonProps {
    label: string;
}

// Mirrors the picker card so the company list lands in place.
export const TenantPickerSkeleton: React.FC<TenantPickerSkeletonProps> = ({ label }) => (
    <div className="flex items-center justify-center min-h-screen bg-surface px-xl">
        <div data-testid="tenant-picker-skeleton" role="status" aria-busy="true" className="bg-primary-50 border border-line-subtle rounded-lg w-full max-w-lg p-xl">
            <span className="sr-only">{label}</span>
            <div aria-hidden="true">
                <SkeletonBar className="h-5.5 w-48 mb-s" />
                <SkeletonBar className="h-3 w-64 max-w-full mb-l" />
                {[1, 2, 3].map(i => (
                    <div key={i} className="flex items-center gap-l py-m border-b border-line-subtle">
                        <SkeletonBar className="h-3 w-12 shrink-0" />
                        <SkeletonBar className="h-3 flex-1" />
                        <SkeletonBar className="h-3 w-20 shrink-0" />
                    </div>
                ))}
            </div>
        </div>
    </div>
);
